function provideLocationState(locationToState) {
	return (WrappedComponent) => {
		class LocationState extends React.Component {
			render() {
				// Combine route params and url params into a single object
				if (this.props.match) {
					var params = this.props.match.params
				}	else {
					var params = {}
				}
				if (this.props.location) {
					var search = $wr.getQueryObject(this.props.location.search)
				} else {
					var search = {}
				}

				var locationState = _.extend({},
					params,
					search
				)
				if (locationToState) {
					locationState = locationToState(locationState);
				}
				var mergedProps = _.extend({}, this.props, { locationState: locationState }); 

				return React.createElement(WrappedComponent, mergedProps);
			}
		}
		LocationState.WrappedComponent = WrappedComponent;

		return LocationState;
	}
}

module.exports = {
	provideLocationState
}


// WEBPACK FOOTER //
// ./modules/components/utility/hoc/LocationState.js